// Indicates if the client supports WebSockets.
module.exports = global.WebSocket !== undefined;



// WEBPACK FOOTER //
// ./src/js/helpers/isWebSocketSupported.js